module.exports = __webpack_public_path__ + "./Ivy_a828c459b1c0e414d68dbba38c947d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/Ivy.jpg
// module id = 480
// module chunks = 0